import { forwardRef } from "react";

import dynamic from "next/dynamic";
import { FieldValues } from "react-hook-form";

import { RadioGroupProps, RadioGroupSsrProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
const DynamicDashboardRadioGroup = dynamic(
  () => import("./DashboardRadioGroupSsr").then((mod) => mod.DashboardRadioGroupSsr),
  { ssr: false }
) as <T extends FieldValues>(props: RadioGroupSsrProps<T>) => React.ReactElement;

// Wrap dynamic component with forwardRef and pass ref as forwardedRef prop
// This is necessary because next/dynamic doesn't properly forward refs
const DashboardRadioGroupInner = forwardRef(function DashboardRadioGroupInner<T extends FieldValues>(
  props: RadioGroupProps<T>,
  ref: React.Ref<HTMLDivElement>
) {
  return <DynamicDashboardRadioGroup {...props} forwardedRef={ref} />;
});

export const DashboardRadioGroup = DashboardRadioGroupInner as (<T extends FieldValues>(
  props: RadioGroupProps<T> & React.RefAttributes<HTMLDivElement>
) => React.ReactElement) & {
  displayName: string;
};

DashboardRadioGroup.displayName = "DashboardRadioGroup";
